export const heroData = {
  tag: "奇幻脑洞 · 高能连载",
  title: "奇妙漫画",
  subtitle: "异世界穿越 · 魔法战斗 · 脑洞冒险",
  slogan:
    "点开即看高能剧情，异世界之门为你打开。跨越时空的冒险、炽热的魔法对决、颠覆想象的脑洞故事，奇妙漫画奇幻世界，一触即发。",
  stats: [
    { value: "680+", label: "独家连载" },
    { value: "1200+", label: "累计话数" },
    { value: "480万", label: "追更读者" },
    { value: "24h", label: "每日更新" },
  ],
};

export type Manga = {
  id: number;
  name: string;
  category: string;
  tag: string;
  status: string;
  score: string;
  fans: string;
  chapter: string;
  updated: string;
  desc: string;
  cover: string;
  author: string;
};

export const mangaList: Manga[] = [
  {
    id: 1,
    name: "破晓异世录",
    category: "异世界",
    tag: "穿越",
    status: "连载中",
    score: "9.6",
    fans: "52.3万",
    chapter: "第 168 话",
    updated: "2 小时前",
    author: "洛尘工作室",
    desc: "一位考古系研究生意外坠入失落的魔法纪元，身怀上古秘术卷轴，在帝国与龙族之间周旋，开启改写世界线的高能冒险。",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20fantasy%20comic%20cover%20illustration%20of%20a%20young%20hero%20with%20a%20glowing%20golden%20magic%20scroll%2C%20crackling%20amber%20lightning%20and%20floating%20ancient%20runes%2C%20deep%20ink%20background%2C%20cinematic%20warm%20gold%20and%20ember%20tones%2C%20epic%20atmosphere%2C%20manga%20art%20style%2C%20high%20detail&width=400&height=560&seq=manga-cover-01&orientation=portrait",
  },
  {
    id: 2,
    name: "契约之焰",
    category: "魔法",
    tag: "战斗",
    status: "连载中",
    score: "9.4",
    fans: "41.7万",
    chapter: "第 132 话",
    updated: "5 小时前",
    author: "灼日画社",
    desc: "被逐出魔法学院的少年与上古炎龙签订契约，从见习学徒一路燃到王都圣战，火焰之下隐藏着改写命运的真相。",
    cover: "https://readdy.ai/api/search-image?query=A%20stylized%20dark%20fantasy%20comic%20cover%20of%20a%20young%20magician%20wreathed%20in%20blazing%20orange%20and%20gold%20fire%2C%20floating%20flame%20runes%2C%20deep%20charcoal%20background%2C%20warm%20ember%20lighting%2C%20cinematic%20manga%20illustration%2C%20high%20detail&width=400&height=560&seq=manga-cover-02&orientation=portrait",
  },
  {
    id: 3,
    name: "脑洞空想家",
    category: "脑洞",
    tag: "脑洞",
    status: "连载中",
    score: "9.2",
    fans: "37.9万",
    chapter: "第 96 话",
    updated: "8 小时前",
    author: "白日梦工厂",
    desc: "能把想象具现化的少年，随手一画就是新世界。当所有离谱的脑洞开始成真，他必须为自己的想象力负责到底。",
    cover: "https://readdy.ai/api/search-image?query=A%20whimsical%20dark%20fantasy%20comic%20cover%20of%20a%20young%20dreamer%20drawing%20magical%20creatures%20that%20float%20out%20of%20a%20sketchbook%2C%20glowing%20gold%20and%20warm%20orange%20sparks%2C%20deep%20ink%20background%2C%20surreal%20imaginative%20scene%2C%20cinematic%20manga%20art%2C%20high%20detail&width=400&height=560&seq=manga-cover-03&orientation=portrait",
  },
  {
    id: 4,
    name: "深渊冒险团",
    category: "冒险",
    tag: "冒险",
    status: "连载中",
    score: "9.1",
    fans: "33.5万",
    chapter: "第 141 话",
    updated: "1 天前",
    author: "极地星社",
    desc: "由一群被诅咒的落魄者组成的冒险团，踏上讨伐深渊的征途。每个副本背后，都是一段被遗忘的古老传说。",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20comic%20cover%20of%20a%20ragtag%20adventurer%20party%20standing%20before%20a%20vast%20glowing%20abyss%20chasm%2C%20warm%20amber%20torchlight%20and%20gold%20crystals%2C%20deep%20charcoal%20background%2C%20cinematic%20manga%20illustration%2C%20epic%20adventure%20feel%2C%20high%20detail&width=400&height=560&seq=manga-cover-04&orientation=portrait",
  },
  {
    id: 5,
    name: "星界漫游者",
    category: "异世界",
    tag: "冒险",
    status: "连载中",
    score: "9.3",
    fans: "46.8万",
    chapter: "第 120 话",
    updated: "6 小时前",
    author: "星海拾光",
    desc: "少女穿梭于崩坏的星界之间，修复被撕裂的法则。每一次跃迁都是新的世界，每一颗星都藏着不为人知的秘密。",
    cover: "https://readdy.ai/api/search-image?query=A%20dreamy%20dark%20fantasy%20comic%20cover%20of%20a%20girl%20floating%20among%20broken%20planets%20and%20glowing%20gold%20cosmic%20threads%2C%20warm%20amber%20starlight%2C%20deep%20ink%20space%20background%2C%20cinematic%20manga%20illustration%2C%20ethereal%20and%20epic%2C%20high%20detail&width=400&height=560&seq=manga-cover-05&orientation=portrait",
  },
  {
    id: 6,
    name: "黑塔的禁书",
    category: "魔法",
    tag: "学院",
    status: "已完结",
    score: "9.5",
    fans: "58.1万",
    chapter: "全 210 话",
    updated: "3 天前",
    author: "墨鸦书阁",
    desc: "在魔法学院的地下黑塔，藏着一本记载禁忌咒术的书籍。谁能破解它的秘密，谁就能重写整个魔法世界的秩序。",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20fantasy%20comic%20cover%20of%20an%20ancient%20black%20tower%20and%20a%20glowing%20forbidden%20golden%20grimoire%2C%20warm%20ember%20rune%20light%2C%20deep%20charcoal%20background%2C%20cinematic%20manga%20illustration%2C%20mysterious%20and%20grand%2C%20high%20detail&width=400&height=560&seq=manga-cover-06&orientation=portrait",
  },
  {
    id: 7,
    name: "幻境回响",
    category: "脑洞",
    tag: "悬疑",
    status: "连载中",
    score: "8.9",
    fans: "28.6万",
    chapter: "第 84 话",
    updated: "1 天前",
    author: "回声工作室",
    desc: "城市中不断出现来自幻境的回响，只有男主能听见并进入其中。每一个幻境都是某个人记忆的碎片，真相逐渐浮现。",
    cover: "https://readdy.ai/api/search-image?query=A%20moody%20dark%20fantasy%20comic%20cover%20of%20a%20young%20man%20seeing%20echoes%20of%20ghostly%20golden%20worlds%20reflected%20in%20mirrors%2C%20warm%20amber%20and%20ember%20tones%2C%20deep%20ink%20background%2C%20cinematic%20manga%20illustration%2C%20mysterious%20atmosphere%2C%20high%20detail&width=400&height=560&seq=manga-cover-07&orientation=portrait",
  },
  {
    id: 8,
    name: "龙裔骑士",
    category: "冒险",
    tag: "热血",
    status: "连载中",
    score: "9.0",
    fans: "39.2万",
    chapter: "第 155 话",
    updated: "4 小时前",
    author: "北境铁骑",
    desc: "身负龙族血脉的少年骑士，为守护故土踏上征途。龙焰与骑士之魂交炽，写下属于北境的史诗传奇。",
    cover: "https://readdy.ai/api/search-image?query=A%20majestic%20dark%20fantasy%20comic%20cover%20of%20a%20dragon%20knight%20in%20armor%20with%20a%20golden%20dragon%20silhouette%20behind%2C%20warm%20amber%20and%20orange%20flame%20light%2C%20deep%20charcoal%20background%2C%20cinematic%20manga%20illustration%2C%20heroic%20and%20epic%2C%20high%20detail&width=400&height=560&seq=manga-cover-08&orientation=portrait",
  },
];

export const rankingList = [
  {
    rank: 1,
    name: "黑塔的禁书",
    category: "魔法",
    score: "9.5",
    fans: "58.1万",
    chapter: "全 210 话",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20fantasy%20comic%20cover%20of%20an%20ancient%20black%20tower%20and%20a%20glowing%20forbidden%20golden%20grimoire%2C%20warm%20ember%20rune%20light%2C%20deep%20charcoal%20background%2C%20cinematic%20manga%20illustration%2C%20high%20detail&width=300&height=420&seq=rank-cover-01&orientation=portrait",
  },
  {
    rank: 2,
    name: "破晓异世录",
    category: "异世界",
    score: "9.6",
    fans: "52.3万",
    chapter: "第 168 话",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20fantasy%20comic%20cover%20illustration%20of%20a%20young%20hero%20with%20a%20glowing%20golden%20magic%20scroll%2C%20crackling%20amber%20lightning%2C%20deep%20ink%20background%2C%20warm%20gold%20and%20ember%20tones%2C%20cinematic%20manga%20art%2C%20high%20detail&width=300&height=420&seq=rank-cover-02&orientation=portrait",
  },
  {
    rank: 3,
    name: "星界漫游者",
    category: "异世界",
    score: "9.3",
    fans: "46.8万",
    chapter: "第 120 话",
    cover: "https://readdy.ai/api/search-image?query=A%20dreamy%20dark%20fantasy%20comic%20cover%20of%20a%20girl%20floating%20among%20broken%20planets%20and%20glowing%20gold%20cosmic%20threads%2C%20warm%20amber%20starlight%2C%20deep%20ink%20space%20background%2C%20cinematic%20manga%20illustration%2C%20high%20detail&width=300&height=420&seq=rank-cover-03&orientation=portrait",
  },
  {
    rank: 4,
    name: "契约之焰",
    category: "魔法",
    score: "9.4",
    fans: "41.7万",
    chapter: "第 132 话",
    cover: "https://readdy.ai/api/search-image?query=A%20stylized%20dark%20fantasy%20comic%20cover%20of%20a%20young%20magician%20wreathed%20in%20blazing%20orange%20and%20gold%20fire%2C%20floating%20flame%20runes%2C%20deep%20charcoal%20background%2C%20cinematic%20manga%20illustration%2C%20high%20detail&width=300&height=420&seq=rank-cover-04&orientation=portrait",
  },
  {
    rank: 5,
    name: "龙裔骑士",
    category: "冒险",
    score: "9.0",
    fans: "39.2万",
    chapter: "第 155 话",
    cover: "https://readdy.ai/api/search-image?query=A%20majestic%20dark%20fantasy%20comic%20cover%20of%20a%20dragon%20knight%20in%20armor%20with%20a%20golden%20dragon%20silhouette%20behind%2C%20warm%20amber%20flame%20light%2C%20deep%20charcoal%20background%2C%20cinematic%20manga%20illustration%2C%20high%20detail&width=300&height=420&seq=rank-cover-05&orientation=portrait",
  },
];

export const categories = [
  {
    name: "异世界",
    icon: "ri-sparkling-2-line",
    count: 186,
    desc: "穿越重生、异界冒险，一步踏进全新的世界。",
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20fantasy%20illustration%20of%20a%20gateway%20portal%20opening%20into%20a%20glowing%20golden%20foreign%20world%2C%20warm%20amber%20light%2C%20deep%20ink%20background%2C%20epic%20isekai%20atmosphere%2C%20manga%20style%2C%20high%20detail&width=640&height=400&seq=cat-isekai-01&orientation=landscape",
  },
  {
    name: "魔法",
    icon: "ri-magic-line",
    count: 142,
    desc: "咒术对决、学院秘史，点燃炽热的魔能。",
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20fantasy%20illustration%20of%20a%20magician%20casting%20a%20blazing%20golden%20spell%20with%20floating%20rune%20circles%2C%20warm%20orange%20and%20amber%20fire%2C%20deep%20charcoal%20background%2C%20manga%20style%2C%20high%20detail&width=640&height=400&seq=cat-magic-01&orientation=landscape",
  },
  {
    name: "脑洞",
    icon: "ri-lightbulb-flash-line",
    count: 118,
    desc: "颠覆想象的空想盛宴，脑洞大开的奇思妙想。",
    image: "https://readdy.ai/api/search-image?query=A%20surreal%20dark%20fantasy%20illustration%20of%20a%20lamp%20emitting%20golden%20imaginative%20sparks%20and%20floating%20dreamlike%20creatures%2C%20warm%20amber%20glow%2C%20deep%20ink%20background%2C%20whimsical%20creative%20manga%20style%2C%20high%20detail&width=640&height=400&seq=cat-brain-01&orientation=landscape",
  },
  {
    name: "冒险",
    icon: "ri-compass-3-line",
    count: 156,
    desc: "热血远征、秘境探索，踏上未知的征途。",
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20fantasy%20illustration%20of%20an%20adventurer%20party%20with%20torches%20exploring%20a%20glowing%20golden%20ancient%20ruin%2C%20warm%20amber%20torchlight%2C%20deep%20charcoal%20background%2C%20epic%20manga%20style%2C%20high%20detail&width=640&height=400&seq=cat-adv-01&orientation=landscape",
  },
];

export const testimonials = [
  {
    name: "林小满",
    role: "追更 3 年的老读者",
    avatar: "林",
    text: "从《黑塔的禁书》追到完结，奇妙漫画的奇幻剧情从来没让我失望过。更新速度也快，追起来特别过瘾。",
  },
  {
    name: "陈一帆",
    role: "魔法题材爱好者",
    avatar: "陈",
    text: "魔法战斗的分镜简直燃到爆，每一话的伏笔都能串起来。平台上的魔法漫画质量很高，基本没有踩雷。",
  },
  {
    name: "苏晚晴",
    role: "每天通勤追更",
    avatar: "苏",
    text: "碎片时间点开就能看，分类很清晰，脑洞题材特别对我的胃口。奇妙漫画已经成了我的每日必追。",
  },
];

export const faqs = [
  {
    q: "奇妙漫画是免费观看的吗？",
    a: "是的，奇妙漫画的核心内容全部免费观看，无需付费即可畅读全部连载。我们通过适量广告维持运营，为您提供持续的免费内容。",
  },
  {
    q: "多久更新一次？",
    a: "平台内热门作品保持每日更新，绝大多数连载漫画每周都有多话更新。您可以在「最新更新」栏目查看实时更新的作品与话数。",
  },
  {
    q: "有哪些题材分类？",
    a: "奇妙漫画涵盖异世界、魔法、脑洞、冒险、悬疑、热血等丰富题材。分类齐全，并设有编辑推荐与热门榜单，帮您快速找到心仪的作品。",
  },
  {
    q: "支持哪些设备观看？",
    a: "奇妙漫画支持电脑、平板和手机等各类设备，响应式设计让您在任意屏幕下都能流畅阅读，随时随地追更不中断。",
  },
  {
    q: "如何第一时间获取更新提醒？",
    a: "您可以在页面底部订阅「追漫更新」，留下常用邮箱即可第一时间收到您关注作品的更新提醒，不错过任何高能剧情。",
  },
];